<template>
  <Modal
    :is-open="isOpen"
    :footer-class="loading ? 'hidden' : ''"
    @modal:confirm="onConfirm"
    @modal:cancel="onCancel"
    class="z-10 flex items-center justify-center"
    container-class="max-h-full rounded-lg"
  >
    <Cargando v-if="loading" mensaje="Guardando..." class="px-4 py-2 md:p-6" />
    <div v-else class="overflow-y-auto px-4 py-2 sm:flex sm:items-start md:p-6">
      <div
        class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-yellow-100 sm:mx-0 sm:h-10 sm:w-10"
      >
        <SolidExclamationIcon class="h-6 w-6 text-yellow-500" />
      </div>

      <div class="mt-3 space-y-4 text-center sm:ml-4 sm:mt-0 sm:text-left">
        <h3 class="text-lg font-medium leading-6 text-gray-900" id="modal-title">
          <slot></slot>
        </h3>

        <slot name="before-confirm"></slot>

        <div class="space-y-1">
          <p class="text-base text-gray-900">¿Desea confirmar la operación?</p>
          <p v-if="error" class="text-sm font-medium text-red-500">
            {{ error }}
          </p>
        </div>

        <slot name="after-confirm"></slot>
      </div>
    </div>
  </Modal>
</template>

<script>
import Cargando from '@/components/Core/Cargando.vue'

export default {
  props: {
    isOpen: { type: Boolean, required: true },
  },

  components: {
    Cargando,
  },

  data() {
    return {
      loading: false,
      error: null,
    }
  },

  watch: {
    isOpen(newValue, oldValue) {
      if (newValue) {
        document.querySelector('body').classList.add('overflow-y-hidden')
      } else {
        document.querySelector('body').classList.remove('overflow-y-hidden')
      }
    },
  },

  methods: {
    onConfirm() {
      this.loading = true
      this.error = null

      this.$emit('save', error => {
        this.loading = false
        if (error) this.error = error
        else this.$emit('modal:confirm')
      })
    },
    onCancel() {
      this.error = null
      this.$emit('modal:cancel')
    },
  },

  beforeDestroy() {
    document.querySelector('body').classList.remove('overflow-y-hidden')
  },
}
</script>
